module.exports = "<p>media works!</p>\r\n"